import { Button, LoadingIndicator } from "@light-technology/components";
import { LinkExternal01 } from "@untitledui/icons";
import { format } from "date-fns";
import { utc } from "@date-fns/utc";
import { api } from "../../state/api";
import { type AppAccount, type AppResponse } from "../../state/api.types";
import { formatCurrency } from "../../utilities/currency";
import { InvoiceStatus } from "./InvoiceStatus";

type AccountSlideoutInvoicesProps = {
  account: AppAccount;
  app: AppResponse;
};

export const AccountSlideoutInvoices = (
  props: AccountSlideoutInvoicesProps,
) => {
  const getInvoices = api.useGetInvoicesQuery({
    accountUUID: props.account.uuid,
    appUUID: props.app.uuid,
  });

  if (getInvoices.isLoading) {
    return <LoadingIndicator type="brand-spinner" />;
  }

  if (!getInvoices.data?.data.length) {
    return (
      <div className="text-sm text-tertiary">No invoices for this account</div>
    );
  }

  return (
    <div className="space-y-3xl">
      {getInvoices.data.data.map((invoice) => (
        <div
          key={invoice.number}
          className="flex items-center justify-between gap-md"
        >
          <div className="space-y-xs">
            <div className="flex items-center gap-md">
              <div className="text-md font-semibold">
                {format(invoice.invoice_date, "PPP", { in: utc })}
              </div>
              <InvoiceStatus invoice={invoice} />
            </div>
            <div className="font-mono text-sm text-secondary">
              {formatCurrency(invoice.total)}
            </div>
            <div className="font-mono text-sm text-secondary">
              INV-{invoice.number}
            </div>
          </div>
          <Button
            color="tertiary"
            iconLeading={LinkExternal01}
            href={invoice.pdf}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
      ))}
    </div>
  );
};
